import {
  PRESUPUESTADOR_UPDATE_STATE_PRESUPUESTO_BEGIN,
  PRESUPUESTADOR_UPDATE_STATE_PRESUPUESTO_SUCCESS,
  PRESUPUESTADOR_UPDATE_STATE_PRESUPUESTO_FAILURE,
  PRESUPUESTADOR_UPDATE_STATE_PRESUPUESTO_DISMISS_ERROR,
} from './constants'
import { getEndpoint } from '../../common/backend/endpoints'
import axios from 'axios'

export function updateStatePresupuesto() {
  return (dispatch, getState) => {
    dispatch({
      type: PRESUPUESTADOR_UPDATE_STATE_PRESUPUESTO_BEGIN,
    })

    const {presupuestador = {}} = getState()

    const takingCars = presupuestador?.Taking_cars
    const entregaUsados = presupuestador?.entregaUsados
    const takingCarArray = takingCars?.length > 0 ? takingCars : entregaUsados

    const endpoint = getEndpoint('PRESUPUESTADOR')

    const promise = new Promise((resolve, reject) => {

      //Armo el body
      const body = {
        is_reservation: presupuestador.is_reservation,
        is_nulled: presupuestador.is_nulled,
        stock_id: presupuestador.selectedStock || presupuestador.stock_id,
        taking_cars: takingCarArray
      }

      // si el presupuesto es una reserva, guardo las condiciones comerciales
      if (presupuestador.is_reservation) {
        body.reservation_credits = JSON.stringify(presupuestador.lineasFinancieras)
      }

      const doRequest = axios.put(`${endpoint}/${presupuestador.id_presupuesto}/state`, body)
      doRequest.then(
        (res) => {
          dispatch({
            type: PRESUPUESTADOR_UPDATE_STATE_PRESUPUESTO_SUCCESS,
            data: res,
            state: res?.data?.data?.state || presupuestador.state,
          })
          resolve(res)
        },
        (err) => {
          dispatch({
            type: PRESUPUESTADOR_UPDATE_STATE_PRESUPUESTO_FAILURE,
            data: { error: err.message },
          })
          reject(err)
        },
      )

    })

    return promise
  }
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissupdateStatePresupuestoError() {
  return {
    type: PRESUPUESTADOR_UPDATE_STATE_PRESUPUESTO_DISMISS_ERROR,
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case PRESUPUESTADOR_UPDATE_STATE_PRESUPUESTO_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        updateStatePresupuestoPending: true,
        updateStatePresupuestoError: null,
      }

    case PRESUPUESTADOR_UPDATE_STATE_PRESUPUESTO_SUCCESS:
      // The request is success
      return {
        ...state,
        ...action.data,
        updateStatePresupuestoPending: false,
        updateStatePresupuestoError: null,
        is_reservation: false,
        is_nulled: false,
        state: action.state,
        getPdfError: null,
        pdf: ""
      }

    case PRESUPUESTADOR_UPDATE_STATE_PRESUPUESTO_FAILURE:
      // The request is failed
      return {
        ...state,
        is_reservation: false,
        is_nulled: false,
        updateStatePresupuestoPending: false,
        updateStatePresupuestoError: action.data.error,
      }

    case PRESUPUESTADOR_UPDATE_STATE_PRESUPUESTO_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        updateStatePresupuestoError: null,
      }

    default:
      return state
  }
}
